import React, {useCallback} from "react";
import styled from "styled-components";

import {Link} from "components/link";
import {translate} from "helpers/i18n";
import {isFintro} from "helpers/domain";

const FooterWrapper = styled.footer`
    padding: 1rem 0;
    margin-top: 20px;
    color: grey;
    background-color: white;
    border-top: 1px solid #dddddd;
    text-align: center;
    @media (max-width: 480px) {
       margin-bottom: 75px;
    }
    
    & a {
        margin-right: 1rem;
        font-size: 0.875rem;

        &:hover {
            text-decoration: none;
            font-size: 0.875rem;
        }
    }
`;

export const Footer = () => {
    const handleCookie = useCallback(() => {
        window.PageBus.publish('cc.policy.popup');
    }, []);

    const links = [
        {
            text: translate("footer.disclaimerLink"),
            link: translate("footer.disclaimerLinkURL")
        },
        {
            text: translate("footer.privacyLink"),
            link: translate("footer.privacyLinkURL")
        },
        {
            text: translate("footer.cookieLink"),
            onClick: handleCookie
        },
        {
            text: translate("footer.aboutUsLink"),
            link: translate("footer.aboutUsLinkURL")
        }
    ]

    return (
        <FooterWrapper>
            {links.map((link, index) => {
                if (link.onClick) {
                    return (
                        <Link
                            key={index}
                            text={link.text}
                            onClick={link.onClick}
                        />
                    )
                }

                return (
                    <Link
                        key={index}
                        target="_blank"
                        text={link.text}
                        href={(isFintro() ? 'https://www.fintro.be' : 'https://www.bnpparibasfortis.be') + link.link}
                    />
                )
            })}
        </FooterWrapper>
    );
};
